// src/utils/auth.js

import { API_BASE_URL, apiUrl } from "../config/api";

export const AUTH_BASE_URL = API_BASE_URL;

async function readAuthError(response, fallback) {
  let detail = null;

  try {
    const data = await response.json();
    detail = data?.detail;
  } catch (error) {
    detail = null;
  }

  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg).filter(Boolean).join(", ") || fallback;
  }

  if (detail === "REGISTER_USER_ALREADY_EXISTS") {
    return "That email is already registered.";
  }

  if (typeof detail === "string" && detail) {
    return detail;
  }

  if (response.status === 400 || response.status === 401) {
    return fallback;
  }

  return fallback;
}

export async function registerUser({ email, password, first_name = "", last_name = "" }) {
  const response = await fetch(apiUrl("/auth/register"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, first_name, last_name }),
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(await readAuthError(response, "Could not create that account."));
  }

  return response.json();
}

export async function loginWithPassword(email, password) {
  const response = await fetch(apiUrl("/auth/jwt/login"), {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({ username: email, password }),
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(await readAuthError(response, "Email or password is incorrect."));
  }

  return true;
}

export async function getCurrentUser() {
  try {
    const res = await fetch(apiUrl("/users/me"), {
      credentials: "include",
    });

    if (!res.ok) return null;

    return await res.json();
  } catch (error) {
    return null;
  }
}

export async function logout() {
  try {
    await fetch(apiUrl("/auth/jwt/logout"), {
      method: "POST",
      credentials: "include",
    });
  } catch (error) {}
}
